<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >
        <material-card
          color="green"
          :title="$t('Metrics.tableHeading')"
          :text="$t('Metrics.tableDescription')"
        >
          <v-row>
            <v-col cols="12">
              <v-text-field
                class="float-right"
                v-model="search"
                append-icon="mdi-search"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-data-table
            :search="search"
            :headers="headers"
            :items="metricsWithMetricTabs"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-row>
                  <v-col cols="12">
                    <v-btn
                      :id="`automation-id-Tabs-btn-new`"
                      elevation-4
                      light
                      color="green darken-2"
                      @click="addNew()"
                      class="white--text"
                    >
                      <!-- addNew method toggles the dialog (this is included in the mixinDialogEdit mixin) -->
                      <!-- elements used for automated end to end testing needs an id: automation-id-Clinics-element-description -->
                      <v-icon>
                        mdi-plus
                      </v-icon>
                      {{ $t('Tabs.newButton')}}
                    </v-btn>
                    <v-btn
                      :id="`automation-id-Clinics-btn-refresh`"
                      @click="loadData"
                      text
                      icon
                      color="green"
                      class="float-right">
                      <v-icon>mdi-cached</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-toolbar>
            </template>
            <template v-slot:item.action="{ item }">
              <aurora-data-table-actions
                :items="items"
                :item="item"
                name="Metrics"
                @edit="editItem"
                @delete="deleteItem"
              />
            </template>
            <template v-slot:item.isActive="{ item }">
              <aurora-bool-field :boolValue="item.isActive">
                <template v-slot:true>
                  Yes
                </template>
                <template v-slot:false>
                  No
                </template>
              </aurora-bool-field>
            </template>
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="subheading font-weight-light text-success text--darken-3"
                v-text="header.text"
              />
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
    <aurora-dialog-edit
      :show="show"
      :heading="$t('Tabs.itemHeading')"
      @shown="$refs.metricForm.reset();"
      @cancel="show = false"
      @save="saveItem()"
    >
      <!-- show variable to control modal visibility (this is included in the mixinDialogEdit mixin) -->
      <!-- heading of the dialog box -->
      <!-- cancel handler -->
      <!-- save handler -->
      <template
        slot="form"
      >
        <!-- vue slot containing the form -->
        <v-layout
          row
          wrap
        >
          <v-form
            v-model="valid"
            lazy-validation
            style="width: 90%"
            ref="metricForm"
          >
            <v-select
              v-model="item.metricTabId"
              :items="metricTabs"
              item-text="name"
              item-value="id"
              label="Metric Tab"
            />

            <v-text-field
              v-model="item.name"
              label="Metric Name*"
              required
            />

            <v-text-field
              v-model="item.what"
              label="What is Measured?"
            />

            <v-text-field
              v-model="item.how"
              label="How is it Measured?"
            />

            <v-text-field
              v-model="item.when"
              label="When is it Measured?"
            />

            <v-text-field
              v-model="item.who"
              label="Who Measures?"
            />

            <v-text-field
              v-model="item.details"
              label="Details"
            />

            <v-text-field
              v-model="item.weight"
              type="number"
              label="Scoring Weight"
            />

            <v-checkbox
              v-model="item.isActive"
              label="Is Active"
            />
          </v-form>
        </v-layout>
      </template>
    </aurora-dialog-edit>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { mixinDialogEdit, mixinOdataPage } from 'vuetify-aurora'; // mixins for basic dialog functions

const odataPage = Object.assign({}, mixinOdataPage.create('metrics', 'metric')); // generates mixin for OData page

export default {
  mixins: [mixinDialogEdit, odataPage],
  data: () => ({
    search: '',
    headers: [
      {
        sortable: true,
        text: 'Metric',
        value: 'metricTab.name',
      },
      {
        sortable: true,
        text: 'Name',
        value: 'name',
      },
      {
        sortable: true,
        text: 'Input',
        value: 'inputSource',
      },
      {
        sortable: true,
        text: 'What',
        value: 'what',
      },
      {
        sortable: true,
        text: 'When',
        value: 'when',
      },
      {
        sortable: true,
        text: 'How',
        value: 'how',
      },
      {
        sortable: true,
        text: 'Weight',
        value: 'weight',
      },
      {
        sortable: false,
        text: 'Is Active',
        value: 'isActive',
      },
      {
        sortable: false,
        text: '',
        value: 'action',
      },
    ],
    valid: false,
  }),
  computed: {
    ...mapGetters('odata', ['metricTabs']),
    ...mapState('metrics', ['metricsWithMetricTabs']),
  },
  mounted() {
    this.loadMetricsWithMetricTabs();
    this.$store.dispatch('odata/load.metricTabs');
  },
  destroyed() {
    this.$off('aurora.add');
  },
  methods: {
    ...mapActions('metrics', ['loadMetricsWithMetricTabs']),
  },
};
</script>
